document.addEventListener("DOMContentLoaded", function () {

  const dropdownContents = document.querySelectorAll('.dropdown-content');
  const bodyTopPadding = document.querySelector('body');

  function measureNavHeight() {
    const navHeight = document.getElementById('header').offsetHeight;

    dropdownContents.forEach((dropdownContent) => {
      dropdownContent.style.top = navHeight + 'px';
    });
    bodyTopPadding.style.paddingTop = navHeight + 'px';
  }
  
  measureNavHeight();
  window.addEventListener('resize', measureNavHeight);
  
  // Set the top value of .dropdown-content for all elements with the class

  var dropdownButtons = document.querySelectorAll('.dropdown .js-dropdown-btn');
  var closeButtons = document.querySelectorAll('.dropdown .js-dropdown-close-button');

  function openDropdown(event) {

    // Reference the clicked dropdown button
    var clickedDropdownButton = event.target;

    // Toggle the 'open' class for the clicked dropdown button
    Array.from(dropdownButtons).filter(d => d !== clickedDropdownButton).forEach(function (dropdownButton) {
      dropdownButton.classList.remove('open');
      dropdownButton.setAttribute('aria-expanded', 'false');
      clickedDropdownButton.closest('.dropdown').querySelector('.dropdown-content').setAttribute('aria-hidden', 'true');
    });
    clickedDropdownButton.classList.toggle('open');

    var contentIsOpen = clickedDropdownButton.classList.contains('open');

    clickedDropdownButton.closest('.dropdown').querySelector('.dropdown-content').setAttribute('aria-hidden', contentIsOpen ? 'false' : 'true');
    clickedDropdownButton.setAttribute('aria-expanded', !contentIsOpen ? 'false' : 'true');

    // Hide all other dropdowns
    document.querySelectorAll('.dropdown-content').forEach(function (otherDropdownContent) {
      otherDropdownContent.style.display = (otherDropdownContent === clickedDropdownButton.nextElementSibling && contentIsOpen) ? 'block' : 'none';
    });
  }

  function closeDropdown(event) {
    var closeableContent = event.currentTarget.closest('.dropdown').querySelector('.js-dropdown-btn');
    var evt = new MouseEvent('click');
    // If cancelled, don't dispatch our event
    closeableContent.dispatchEvent(evt);
  }

  // Add click event listeners to the dropdown buttons
  dropdownButtons.forEach(function (dropdownButton) {
    dropdownButton.addEventListener('click', openDropdown);
  });

  closeButtons.forEach(function (closeButton) {
    closeButton.addEventListener('click', closeDropdown);
  });

  // Add click event listener to the document to hide dropdowns when clicking outside
  document.addEventListener('click', function (event) {
    var target = event.target;
    var dropdownContent = target.closest('.dropdown-content');
    if (!target.matches('.dropdown .js-dropdown-btn') && (dropdownContent === null || !dropdownContent.contains(target))) {
      dropdownContents.forEach(function (dropdownContent) {
        dropdownContent.style.display = 'none';
      });

      // Remove the 'open' class from all dropdown buttons
      dropdownButtons.forEach(function (dropdownButton) {
        dropdownButton.classList.remove('open');
      });
    }
  });







  const mainmenuContent = document.querySelector('.js-mainmenuContainer-content');
  const toggleButton = document.querySelector('.js-toggleMainMenu-btn');

  if (mainmenuContent) {
    function toggleMainMenu() {
      // Toggle the content-open class
      mainmenuContent.classList.toggle('content-open');
    }

    function handleResize() {
      if (window.innerWidth >= 1024) {
        mainmenuContent.classList.add('content-open');
      } else {
        mainmenuContent.classList.remove('content-open');
      }
    }

    window.addEventListener('resize', handleResize);

    // Attach click event listener to the document
    document.addEventListener('click', function (event) {
      // Check if the clicked element is the toggle button or its descendant
      if (event.target.closest('.js-toggleMainMenu-btn')) {
        toggleMainMenu();
      }
    });

    handleResize(); // Call handleResize initially to set the initial state
  } else {
    console.log("no menu!");
  }
  
  
  
  
});


